<template>
  <!-- 出口 -->
  <el-dialog
    title="选择出口商品对应分类"
    :visible.sync="exportDiaVisible"
    width="1000px"
    :before-close="closeExportDia"
    :close-on-click-modal="false"
    :append-to-body="true"
    class="audit-record"
  >
    <!-- <div class="search-box">
      <el-form
        :model="listQuery"
        ref="listQuery"
        size="small"
        class="search-form"
      >
        <el-form-item label="商品名称：" label-width="92px" prop="">
          <el-input v-model="listQuery.desc" placeholder="商品名称"></el-input>
        </el-form-item>
        <el-form-item label-width="30px">
          <div class="search-btn">
            <div class="btn reset-btn" size="small" @click="handleReset">
              重置
            </div>
            <div class="btn submit-btn" size="small" @click="handleSearch">
              查询
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div> -->
    <div class="list-box">
      <el-table
        max-height="391"
        :data="tableData"
        ref="tableData"
        border
        size="small"
        style="width: 100%"
        :header-cell-style="{ background: '#F5F5F5' }"
        v-loading="tableLoading"
      >
        <!-- <el-table-column label="序号" width="60px">
          <template #default="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column> -->
        <el-table-column
          label="图片"
          prop="productName"
          width="60"
          key="0"
          fixed="left"
          align="center"
        >
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.defaultImage"
              class="default-img"
              :src="scope.row.defaultImage"
              :preview-src-list="[scope.row.defaultImage]"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column label="商品名称" min-width="320" key="1" fixed="left" align="center">
          <template slot-scope="{ row }">
            <el-link
              style="justify-content: start; width: 100%; text-align:left;"
              type="primary"
              @click="
                goToUrl('/productDetail', {
                  productAuditId: row.productAuditId,
                })
              "
            >
              {{ row.skuName }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column label="商品编号" min-width="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.skuCode }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="brandName"
          label="品牌"
          min-width="160"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="categoryName"
          label="所属分类"
          min-width="160"
          align="center"
        ></el-table-column>
        <el-table-column label="选择出口商品分类" min-width="160" align="center">
          <template #default="scope">
            <el-select
              v-model="scope.row.mymdmtemplatecode"
              @change="
                taxRateChange($event, scope.$index, scope.row.skuId, scope.row.productTypeList)
              "
              placeholder="选择出口商品分类"
            >
              <el-option
                v-for="(item, index) in scope.row.productTypeList"
                :key="index"
                :label="item.mdmtemplatename"
                :value="item.mdmtemplatecode"
              >
                <span>{{ item.mdmtemplatename }}</span>
              </el-option>
            </el-select>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px" v-if="notLength !== 0">
      您选择的{{ allLength }}条商品中，{{ notLength }}条无法推送，具体原因请见页面上方报错。
    </div>
    <div style="margin-top: 10px"></div>
    <div slot="footer">
      <div class="default-btn btn" @click="closeExportDia">关闭</div>
      <el-button :loading="btnLoading" class="submit-btn btn" @click="submitExport">
        确认出口商品
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import api from "../../../api/product";
export default {
  props: {
    exportDiaVisible: {
      type: Boolean,
      default: false,
    },
    goods: {
      type: Array,
      default() {
        return [];
      },
    },
    notLength: {
      type: Number,
      default: 0,
    },
    allLength: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      tableLoading: false,
      listQuery: {
        pageNum: 1,
        pageSize: 10,
      },
      cloneSelectProductsForm: {},
      total: 0,
      tableData: [],
      idKey: "skuid",
      submitList: [],
      btnLoading: false,
    };
  },
  watch: {
    exportDiaVisible(newVal) {
      if (newVal) {
        this.submitList = [];
        const skuIds = this.goods.map(item => item.skuId);
        this.getList(skuIds);
      }
    },
  },
  methods: {
    taxRateChange(event, index, skuId, list) {
      console.log(event, index, skuId, list, "dsfsdfs");
      const productTypeObj = list.find(item => item.mdmtemplatecode === event);
      const item = {
        skuId,
        productTypeList: [productTypeObj],
      };
      this.submitList[index] = item;
      /*
          [{
            skuId: '111111',
            productTypeList: list
          }]
      */
      console.log(this.submitList, " this.submitList");
    },
    async submitExport() {
      let flag = false;
      this.tableData.forEach(item => {
        if (item.mymdmtemplatecode === "") {
          flag = true;
        }
      });
      if (flag) {
        this.$message.warning("列表项选择出口商品分类有未选中的项,请选择后再试");
        return;
      }
      try {
        this.btnLoading = true;
        const res = await api.pushExport(this.submitList);
        this.btnLoading = false;
        if (res.code === "200") {
          this.$emit("pushExportSuccess", "success");
          this.closeExportDia();
        } else {
          this.closeExportDia();
        }
      } catch (err) {
        console.log(err);
        this.closeExportDia();
      }
    },
    // 获取列表数据
    async getList(skuIds) {
      this.tableData = [];
      try {
        this.tableLoading = true;
        const res = await api.pushExportList(skuIds);
        this.tableLoading = false;
        res.data.forEach(item => {
          item.mymdmtemplatecode = "";
        });
        this.tableData = [...res.data];
        console.log(res);
      } catch (err) {
        console.log(err);
        this.tableLoading = false;
      }
    },
    closeExportDia() {
      this.$emit("update:exportDiaVisible", false);
    },
  },
};
</script>
<style lang="scss" scoped>
// 列表重置样式-开始
::v-deep .el-table__header .cell {
  .icon-question {
    height: 18px;
    width: 18px;
    line-height: 18px;
    text-align: center;
    border-radius: 50%;
    border: 1px solid #c5c5c5;
    color: #c5c5c5;
    display: inline-block;
    margin-left: 10px;
    &:hover {
      color: #fff;
      background-color: #c5c5c5;
    }
  }
}
::v-deep .el-table__row .cell {
  font-size: 12px;
  white-space: normal;
  padding-left: 6px;
  padding-right: 6px;
  .el-button {
    font-size: 12px;
  }
  .el-input__inner {
    padding: 0 6px;
  }
  .edit-info {
    color: #c0c4cc;
  }
}
::v-deep .el-table--small td,
::v-deep .el-table--small th {
  padding: 6px 0;
}
::v-deep .el-table--small .el-table-column--selection {
  .cell {
    padding-left: 10px;
    padding-right: 10px;
    .el-checkbox__inner {
      border-radius: 0;
    }
  }
}
// 列表重置样式-结束

// dialog 重置样式开始
::v-deep .el-dialog__header {
  background: #f5f5f5;
  height: 40px;
  padding: 0 20px;
  line-height: 40px;
  .el-dialog__headerbtn {
    top: 8px;
  }
  .el-dialog__title {
    font-size: 14px;
  }
}
// dialog 重置样式结束

.audit-record {
  .search-form {
    display: flex;
    justify-content: center;
    ::v-deep .el-form-item {
      display: inline-block;
      margin-right: 10px;
      vertical-align: top;
    }
    ::v-deep .el-input__inner {
      border-radius: 0;
    }
  }
  .search-box {
    background: #fff;
    ::v-deep .el-form-item--small.el-form-item {
      margin-bottom: 10px;
      margin-right: 20px;
    }
    .search-btn {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin-bottom: 16px;

      .btn {
        min-width: 80px;
        padding: 0 10px;
        text-align: center;
        height: 30px;
        line-height: 28px;
        cursor: pointer;
        border-radius: 0;
      }

      .reset-btn {
        background: #e8efff;
        border: 1px solid #2587ff;
        color: #2587ff;
        margin-right: 30px;
        line-height: 27px;
        &:hover,
        :active {
          background-color: #126edf;
          color: #fff;
        }
      }
      .submit-btn {
        background: #2587ff;
        border: 1px solid #2587ff;
        color: #ffffff;
        &:hover,
        :active {
          background-color: #126edf;
        }
      }
    }
  }
  /* .list-box {
    max-height: 260px;
  } */

  .pagination-box {
    text-align: right;
    margin-top: 20px;
    ::v-deep .el-pagination {
      button {
        height: 30px;
        color: #999;
      }
      .el-select {
        .el-input__inner {
          border-radius: 0;
          height: 30px;
        }
      }
      .el-input__inner {
        border-radius: 0;
        height: 30px;
        color: #999;
      }
      .el-select-dropdown__item,
      .el-pagination__jump,
      .el-pagination__total {
        color: #999;
        line-height: 30px;
      }
      .el-pager {
        li {
          border-radius: 0;
          border: 1px solid #d9d9d9;
          line-height: 28px;
          text-align: center;
          margin-left: 10px;
          width: 40px;
          height: 30px;
          color: #999;
          &:first-child {
            margin-left: 0;
          }
          &.active {
            background: #2587ff;
            border: none;
            color: #fff;
          }
        }
      }
    }
  }
  ::v-deep .el-dialog__body {
    padding: 10px;
  }

  ::v-deep .el-dialog__footer > div {
    display: flex;
    justify-content: center;
    .btn {
      min-width: 80px;
      padding: 0 10px;
      text-align: center;
      height: 30px;
      line-height: 28px;
      cursor: pointer;
      border-radius: 0;
      padding: 0;
      margin-right: 10px;
    }
    .btn {
      min-width: 80px;
      padding: 0 10px;
      text-align: center;
      height: 30px;
      line-height: 28px;
      cursor: pointer;
      border-radius: 0;
    }

    .reset-btn {
      background: #e8efff;
      border: 1px solid #2587ff;
      color: #2587ff;
      margin-right: 30px;
      line-height: 27px;
      &:hover,
      :active {
        background-color: #126edf;
        color: #fff;
      }
    }
    .submit-btn {
      background: #2587ff;
      border: 1px solid #2587ff;
      color: #ffffff;
      &:hover,
      :active {
        background-color: #126edf;
      }
    }

    .default-btn {
      background: #fff;
      border: 1px solid #dcdfe6;
      &:hover {
        border-color: #2587ff;
        color: #2587ff;
      }
    }
  }
}
</style>
